import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "dw-statement" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dw_loader = _resolveComponent("dw-loader")!
  const _component_dw_button = _resolveComponent("dw-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dw-statement__container", { 'container--failed': _ctx.failed }])
    }, [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_dw_loader, { key: 0 }))
        : (_ctx.failed)
          ? (_openBlock(), _createBlock(_component_dw_button, {
              key: 1,
              onClick: _ctx.onReload
            }, {
              default: _withCtx(() => [
                _createTextVNode("Попробовать еще раз")
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
      ((_ctx.loading && _ctx.loadingText) || _ctx.failed)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["dw-statement__text", { 'text--failed': _ctx.failed }])
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.loadingText), 1)
                ], 64))
              : (_ctx.failed)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("При инициализации рабочего места диспетчера произошла ошибка")
                  ], 64))
                : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}